import React, { useState } from "react"

import Swal from "sweetalert2"
import {URL} from "../../config"
// import "./styles_forms/Register.css"

const Register = () => {

	const [formData, setFormData] = useState({})

	const onChangeHandler = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		})
	}
	// console.log(formData)


	const onSubmitHandler = (e) => {
		e.preventDefault()
		fetch(`${URL}/users`, {
			method: "POST",
			body: JSON.stringify(formData),
			headers : {
				"Content-Type" : "application/json"
			}
		})
		.then(res => res.json())
		.then(data => {
			if(data.status === 200){

				Swal.fire({
					icon: 'success',
					text: data.message
				})
				window.location.href="/login"

			} else {
				Swal.fire({
					icon: 'error',
					text: data.message,
					timer: 3500,
					showConfirmButton: false
				})
			}
		})
	}

	return(
		<div className="register-background">
			<div className="container col-sm-5 mx-auto">
				<div className="card register text-white">
					<div className="card-header registerHeaderBackground">
						<h3>Register</h3>
					</div>
					<div className="card-body">
						<form onSubmit={onSubmitHandler}>

								<div className="form-group">
									<label htmlFor="fullname">Fullname</label>
									<input type="text" className="form-control" name="fullname" id="fullname" onChange={onChangeHandler} />
								</div>

								<div className="form-group">
									<label htmlFor="username">Username</label>
									<input type="text" className="form-control" name="username" id="username" onChange={onChangeHandler} />
								</div>

								<div className="form-group">
									<label htmlFor="password">Password</label>
									<input type="password" className="form-control" name="password" id="password" onChange={onChangeHandler} />
								</div>

								<div className="form-group mb-4">
									<label htmlFor="password2">Confirm Password</label>
									<input type="password" className="form-control" name="password2" id="password2" onChange={onChangeHandler} />
								</div>

								<button className="btn btn-primary">Register</button>
						</form>
					</div>					
				</div>
			</div>
		</div>
	)
}

export default Register